import moment from "moment";

/**
 * FullCalendar dayGridMonth `start` is the first visible grid cell (often in
 * the previous month). Using that for navigation + gotoDate walks months
 * backward until a month whose 1st is Sunday (e.g. Jul 2026 → Mar 2026).
 *
 * Prefer `currentStart` (1st of the displayed month) and normalise to YYYY-MM-01.
 */
export function monthAnchorDateFromView(view, rangeStart, dateFormat = "YYYY-MM-DD") {
  const anchor = (view && view.currentStart) || rangeStart;
  return moment(anchor)
    .startOf("month")
    .format(dateFormat);
}

export function sameCalendarMonth(a, b, dateFormat = "YYYY-MM-DD") {
  if (!a || !b) return false;
  return (
    moment(a, dateFormat).format("YYYY-MM") ===
    moment(b, dateFormat).format("YYYY-MM")
  );
}
